import { SITE as types } from 'actions/actionTypes';

const initialState = {
  menu: false
};

const site = (state = initialState, action) => {
  switch (action.type) {
  case types.TOGGLE_MENU: {
    return {
      ...state,
      menu: !state.menu
    };
  }
  default:
    return state;
  }
};

export default site;
